import * as adminService from '@/services/adminApiService.js';
import { formatToDateTimeSec } from '@/utils/formatters.js';

export const dataTableMixin = {
  data() {
    return {
      tableData: [],
      tableDataTotalRows: 0,
      processedTableHeaders: [],
      tableLastUpdateTimes: {},
      uniqueColumnValues: {},
      filters: {},
      searchKeyword: '',
      currentPage: 1,
      pageSize: 20,
      filterOptionsCache: {},
      tableLoadingState: {
        listed: true, nonlisted: true, 'finance-bank': true,
        'finance-stock': true, 'finance-other': true, 'finance-abs': true,
      },
    };
  },
  computed: {
    totalPages() {
      if (this.tableDataTotalRows === 0 || this.pageSize === 0) return 0;
      return Math.max(1, Math.ceil(this.tableDataTotalRows / this.pageSize));
    },
    formattedLastUpdate() {
      const lastUpdateTime = this.tableLastUpdateTimes[this.currentTab];
      return lastUpdateTime ? formatToDateTimeSec(lastUpdateTime) : '暂无记录';
    },
  },
  methods: {
    async loadData() {
      if (this.currentTab === 'reports') return;
      this.tableLoadingState[this.currentTab] = true;
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          filters: this.filters,
          searchKeyword: this.searchKeyword.trim(),
        };
        const response = await adminService.loadAdminTableData(this.currentTab, params);

        this.tableData = response.data || [];
        this.tableDataTotalRows = response.total || 0;
        this.tableLastUpdateTimes = { ...this.tableLastUpdateTimes, [this.currentTab]: response.tableLastUpdate };

        this.processedTableHeaders = response.headers || [];

      } catch (error) {
        alert(error.message || '数据加载失败！');
      } finally {
        this.tableLoadingState[this.currentTab] = false;
      }
    },

    // Excel 上传由 AdminPage.handleExcelUpload + ExcelUploadWizard 处理
    exportExcel() {
      const dbTableName = this.tableNameMap[this.currentTab];
      adminService.exportTableToExcel(dbTableName);
    },
    async loadFilterOptions() {
      if (!this.currentTab || this.currentTab === 'reports') return;
      if (this.filterOptionsCache[this.currentTab]) {
        this.uniqueColumnValues = this.filterOptionsCache[this.currentTab];
        return;
      }
      try {
        const distinctValuesData = await adminService.loadDistinctColumnValues(this.currentTab);
        this.uniqueColumnValues = distinctValuesData || {};
        this.filterOptionsCache[this.currentTab] = this.uniqueColumnValues;
      } catch (error) {
        alert(error.message || '筛选选项加载失败！');
        this.uniqueColumnValues = {};
      }
    },
    handleSearch(keyword) {
      this.searchKeyword = keyword;
      this.currentPage = 1;
      this.loadData();
    },
    handleApplyFilter({ column, values }) {
      this.filters = { ...this.filters, [column]: values };
      this.currentPage = 1;
      this.loadData();
    },
    clearAllFilters(shouldLoadData = true) {
      this.filters = {};
      this.searchKeyword = '';
      this.currentPage = 1;
      if (shouldLoadData) this.loadData();
    },
    changePage(newPage) {
      this.currentPage = newPage;
      this.loadData();
    },
  }
};